import { asyncScheduler, AsyncSubject, Observable, SchedulerLike, Subject } from 'rxjs';

export const cacheWithExpiration = <T>(expirationMs: number, scheduler: SchedulerLike = asyncScheduler, resetCacheOnError: boolean = false) => (
  source: Observable<T>,
) => {
  let cached: AsyncSubject<T> | null;

  return new Observable<T>((observer) => {
    if (!cached) {
      cached = new AsyncSubject();

      source.subscribe(cached);

      cached.subscribe(() => {
        scheduler.schedule(() => {
          cached = null;
        }, expirationMs);
      }, () => {
        if (resetCacheOnError) {
          cached = null;
        }
      });
    }

    return cached.subscribe(observer);
  });
};
